import { Grid, Button, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core"
import { useState } from "react"
import FielBusqueda from "../../../global/FielBusuqeda"
import { useDispatch } from "react-redux"
import { obtenerReservasBusquedaAction } from "../../../ducks/reservasExpiradasDuck"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
const FiltradoReservasExpiradas = () => {
    const [busqueda, setBusqueda] = useState("0")
    const [estatus, setEstatus] = useState("0")
    const dispatch = useDispatch()
    const handleFiltro = () => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerReservasBusquedaAction({ Referencia: (busqueda === "0") ? "NA" : busqueda, EstatusCompra: (estatus === "0") ? "NA" : estatus })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    return (
        <div>
            <Grid
                style={{ margin: "2% 0" }}
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center">
                <Grid item xs={1}>
                    <Button onClick={handleFiltro} color="primary">Filtrar</Button>
                </Grid>
                <Grid item xs={3}>
                    <FielBusqueda
                        setBusqueda={setBusqueda}
                        label="Buscar referencia"
                    />
                </Grid>
                <Grid item xs={3}>
                    <FormControl variant="outlined" style={{ width: "100%", margin: "0 2%" }}>
                        <InputLabel id="lEstatus">Estatus</InputLabel>
                        <Select
                            labelId="lEstatus"
                            id="SEstatus"
                            name="estatus"
                            value={estatus}
                            onChange={(event) => setEstatus(event.target.value)}
                            label="Moneda"
                        >
                            <MenuItem value="0">
                                {"Todos"}
                            </MenuItem>
                            <MenuItem value="1">
                                {"Pendiente Aprobacion"}
                            </MenuItem>
                            <MenuItem value="2">
                                {"Aprobado Cliente"}
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </div>
    )
}
export default FiltradoReservasExpiradas